import Vue from 'vue';
import VueGtag from 'vue-gtag';

Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_ANALYTICS_ID }
});
